import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { PublicHeader } from '../header/PublicHeader.jsx';
import LoadingPage from "../../pages/error-pages/LoadingPage.jsx";
import ChunkErrorBoundary from '../../components/ChunkErrorBoundary.jsx';

import './PublicLayout.css';

const PublicLayout = () => {

    return (
        <div className="home-page">
            <PublicHeader />
            <>
                <ChunkErrorBoundary>
                    <Suspense fallback={<LoadingPage />}>
                        <Outlet />
                    </Suspense>
                </ChunkErrorBoundary>
            </>
        </div>
    );
};

export default PublicLayout;